const app = {
    view_in_crm: "View in CRM",
}

export default app
